import { useId } from 'react';
import { useT } from '@skm/ui';
import { keyFromOtpauth, type Enrolment } from './session.ts';

/**
 * Authenticator set-up shown once (invite acceptance, re-enrolment after an MFA reset) [CR-W2a-42 Q4]: the key-URI as
 * a link (opens the authenticator app on a phone), the key for manual entry, and the recovery codes. Nothing here is
 * stored by the page; it disappears with the component.
 */
export function EnrolmentDetails({ enrolment }: { readonly enrolment: Enrolment }) {
  const t = useT();
  const codesId = useId();
  const manual = keyFromOtpauth(enrolment.otpauthUrl);
  return (
    <section className="skm-enrolment">
      <p>{t('frame.enrol.instructions')}</p>
      <p>
        <a href={enrolment.otpauthUrl}>{t('frame.enrol.openLink')}</a>
      </p>
      {manual ? (
        <dl>
          <dt>{t('frame.enrol.account')}</dt>
          <dd>{manual.account}</dd>
          <dt>{t('frame.enrol.key')}</dt>
          <dd>
            <code>{manual.key}</code>
          </dd>
        </dl>
      ) : null}
      <h2 id={codesId}>{t('frame.enrol.codesTitle')}</h2>
      <p>{t('frame.enrol.codesHint')}</p>
      <ul aria-labelledby={codesId} className="skm-recovery-codes">
        {enrolment.backupCodes.map((c) => (
          <li key={c}>
            <code>{c}</code>
          </li>
        ))}
      </ul>
    </section>
  );
}

/** "I have saved my recovery codes": the next step stays disabled until it is ticked. */
export function SavedCodesCheck(props: {
  readonly checked: boolean;
  readonly onChange: (v: boolean) => void;
}) {
  const t = useT();
  return (
    <label className="skm-check">
      <input
        type="checkbox"
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      {t('frame.enrol.saved')}
    </label>
  );
}
